import React from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { extractName } from 'flow/utils';
import {
    selectContact,
    selectOwnExtensionKey,
} from 'flow/selectors/ExtensionSelectors';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { useModal } from 'flow/contexts/ModalProvider';
import { segmentTrack } from 'flow/actions/segment-actions';
import { TICKET_STRINGS } from 'flow/utils/segment-utils';

interface Props {
    sender: ExtensionKey;
}

const SenderExtension = ({ sender }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();
    const dispatch = useAppDispatch();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const senderContact = useAppSelector((state) =>
        selectContact(state, sender),
    );

    return (
        <button
            type="button"
            onClick={() => {
                openModal('contactModal', { extensionKey: sender });
                dispatch(
                    segmentTrack(TICKET_STRINGS.OPENED_CONTACT_MODAL, {
                        component: 'Message sender name',
                    }),
                );
            }}
        >
            {sender === ownExtensionKey ? (
                <span className="text-chatYou">{i18next.t('chat.you')}</span>
            ) : (
                <span>
                    {extractName(senderContact, i18next.t('Contact.Unknown'))}
                </span>
            )}
        </button>
    );
};

export default SenderExtension;
